import React from 'react';
import PropTypes from 'prop-types';
import SelectNumberInput from './SelectNumberInput';
import NumberInput from './NumberInput';
import SelectInput from './SelectInput';
import { SummaryWrapper, SummaryWrapperNumber } from './SummaryWrapper';

import { countRentLongPrice } from '../../utils/calculator';

class CalculatorRentLong extends React.Component {
    state = {
        summary: '',
        a: parseFloat(this.props.rentLong.a),
        b: parseFloat(this.props.rentLong.b),
        c: parseFloat(this.props.rentLong.c),
        d: this.props.rentLong.d
            ? parseFloat(this.props.rentLong.d)
            : parseFloat(this.props.defaultCarPrice),
        i: this.props.rentLong.i,
        ...this.props.defaultValues
    };

    componentDidMount() {
        this.props.onChange('CalculatorRentLong', this.state);
    }

    onChange = (inputName, values) => {
        this.setState(
            {
                [inputName]: values.floatValue ? values.floatValue : values
            },
            () => {
                const summary = countRentLongPrice(this.state);
                this.setState(
                    {
                        summary: summary ? summary : ''
                    },
                    () => {
                        this.props.onChange('CalculatorRentLong', this.state);
                    }
                );
            }
        );
    };

    render() {
        const { disableCarValue, rentLong } = this.props;

        return (
            <>
                <NumberInput
                    name="d"
                    disabled={disableCarValue}
                    // defaultValue={defaultCarPrice}
                    onChange={this.onChange}
                    title={
                        disableCarValue
                            ? 'Wartość katalogowa (brak możliwości zmiany)'
                            : 'Wartość katalogowa'
                    }
                    value={this.state.d}
                />
                <SelectNumberInput
                    selectData={rentLong.e}
                    name="e"
                    onChange={this.onChange}
                    title="Wpłata własna"
                    value={this.state.e}
                />
                <SelectInput
                    name="f"
                    onChange={this.onChange}
                    selectData={rentLong.f}
                    selected={this.state.f}
                    title="Okres umowy (miesięcy)"
                />
                <SelectInput
                    name="h"
                    onChange={this.onChange}
                    selectData={rentLong.h}
                    selected={this.state.h}
                    title="Limit kilometrów (tys. km)"
                />
                {this.state.summary && (
                    <SummaryWrapper>
                        <label>Rata netto</label>
                        <SummaryWrapperNumber>
                            <NumberInput
                                summary
                                displayType="text"
                                value={this.state.summary}
                            />
                            <span>/mies.</span>
                            <button
                                className="btn-general btn-general--primary"
                                onClick={this.props.showModal}
                            >
                                Dalej
                            </button>
                        </SummaryWrapperNumber>
                    </SummaryWrapper>
                )}
            </>
        );
    }
}

CalculatorRentLong.propTypes = {
    disableCarValue: PropTypes.bool,
    defaultCarPrice: PropTypes.number,
    rentLong: PropTypes.shape({
        a: PropTypes.string.isRequired,
        b: PropTypes.string.isRequired,
        c: PropTypes.string.isRequired,
        f: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired,
        h: PropTypes.arrayOf(PropTypes.string.isRequired).isReqired
    }).isRequired
};

export default CalculatorRentLong;
